import React, { useContext } from "react";
// import Progress from "../Progress";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import { redirectToRealMe } from "../../Services/apiService";
import BackIconWhite from "../../assets/images/BackIconWhite.svg";

const CancelSubmit = ({ handleNext, handleCancel, handleBack }) => {
  return (
    <>
      <div className="intro">
        <h1 className="intro-title-mi" lang="mi-NZ">
          Ngā mihi, kua tae mai tō tono ki te whakakore i tō tuakiri hāpono
        </h1>
        <hr />
        {
          <h1 className="intro-title">
            Thanks, we've received your request to cancel your verified identity
          </h1>
        }

        <div className="step-container">
          <p className="mb-4">
            We're processing your request. We'll let you know once your verified
            identity has been cancelled.
          </p>
        </div>

        <div className="step-button-container">
          <SubmitButton
            text={"Back to RealMe"}
            onClick={redirectToRealMe}
            Icon={BackIconWhite}
          />
        </div>
      </div>
    </>
  );
};

export default CancelSubmit;
